import Goals from './Goals';
import Strengths from './Strengths';
import Weaknesses from './Weaknesses';
import './ClientProfile.css';

const ClientProfile = () => (
    <>
        <div className="clientdashboard-profile-page">
            <Goals />
            <Strengths />
            <Weaknesses />
        </div>
    </>
);

export default ClientProfile;